/**
 * Dynamically fetch new variant html for sections
 */
document.addEventListener('product:variantChanged', async (event) => {
  console.log('product:variantChanged ss:', event);
 

  /**
   * Fetch new variant html
   */
  const mainSectionEl = document.querySelector('[id^="shopify-section-template--"][id$="__main"]');
  const mainSectionId = mainSectionEl.id.replace('shopify-section-', '');

  const sections = [
    {
      id:'product-features-columns',
      type:'product-features-columns',
      class:'product-features-columns' // class of the section to replace with new html
    },
    {
      id:'product-comparison',
      type:'product-comparison',
      class:'product-comparison' // class of the section to replace with new html
    },
    {
      id: mainSectionId,
      type:'main-product',
      class:'section-main-product', // class of the section to replace with new html
      items: [
        {
          class:'product-features__dynamic-content'
        },
        {
          class:'product-features__items'
        },
        {
          class:'cc-accordion-item .product__size-guide'
        },
        {
          class:'size-chart-content .product__size-guide'
        }
      ]
    }
  ];

  try {
    // add loading state
    sections.forEach(section => {
      if (section.id === mainSectionId) {
        section.items.forEach(item => {
          const itemElement = document.querySelector(`.section-main-product .${item.class}`);
          if (itemElement) {
            itemElement.style.opacity = '0.5';
            itemElement.style.pointerEvents = 'none';
          }
        });

        return;
      };

      const sectionElement = document.querySelector(`.${section.class}`);
      if (sectionElement) {
        sectionElement.style.opacity = '0.5';
        sectionElement.style.pointerEvents = 'none';
      }
    });

    const url = new URL(window.location.href);
    url.searchParams.set('variant', event.detail.variant.id);
    url.searchParams.set('sections', sections.map(section => section.id).join(','));
    const response = await fetch(url.toString());
    const data = await response.json();

    sections.forEach(section => {
      const sectionElement = document.querySelector(`.${section.class}`);
      if (sectionElement && section.id !== mainSectionId) {
        sectionElement.innerHTML = data[section.id];
      }

      if (section.id === mainSectionId) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = data[section.id];
        const mainProductHtml = tempDiv;
   
        section.items.forEach(item => {
          const itemElement = document.querySelector(`.section-main-product .${item.class}`);
          const itemHtml = mainProductHtml.querySelector(`.section-main-product .${item.class}`)?.innerHTML;
          if (itemElement && itemHtml) {
            itemElement.innerHTML = itemHtml;
          } else {
            console.log("itemElement not found:", item.class);
          }
        });
      }
    });
  } catch (error) {
    console.error(error);
  } finally {
    // remove loading state
    sections.forEach(section => {
      if (section.id === mainSectionId) {
        section.items.forEach(item => {
          const itemElement = document.querySelector(`.section-main-product .${item.class}`);
          if (itemElement) {
            itemElement.style.opacity = '1';
            itemElement.style.pointerEvents = 'auto';
          }
        });

        return;
      };

      const sectionElement = document.querySelector(`.${section.class}`);
      if (sectionElement) {
        sectionElement.style.opacity = '1';
        sectionElement.style.pointerEvents = 'auto';  
      }
    });
  }
});
